const formHelpers = () => {
    //Input helper
    // Select all input fields of type text and email
    var inputs = document.querySelectorAll('input, textarea');

// Loop over the inputs
    for (var i = 0; i < inputs.length; i++) {

        // Bind the input event to each input
        inputs[i].addEventListener('input', function () {

            // If the input has a value
            if (this.value.trim() !== '') {
                // Add the 'has-value' class if it doesn't exist
                if (!this.classList.contains('has-value')) {
                    this.classList.add('has-value');
                }
            }
            // If the input does not have a value
            else {
                // Remove the 'has-value' class if it exists
                if (this.classList.contains('has-value')) {
                    this.classList.remove('has-value');
                }
            }
        });
    }

    var cf7Forms = document.querySelectorAll('.wpcf7 form');
    cf7Forms.forEach(function(form) {
        var inputs = form.querySelectorAll('input, textarea, select');
        inputs.forEach(function(input) {
            if (!input.id && input.name) {
                input.id = input.name;
            }
        });
    });
}

export default formHelpers;